import BaseModal from '@/vcs/_shared/modals/BaseModal.vue'
import RedirectToLockersOrDeliveries from '@/mixins/redirect-to-lockers-or-deliveries.js'

export default {
  name: 'PromptWithButton',
  mixins: [RedirectToLockersOrDeliveries],
  extends: BaseModal,
  methods: {
    goToDeliveries() {
      this.redirectToLockersOrDeliveries()
      this.close(false)
    },
  },
}
